<template>
	<table class="ban-list">
		<thead>
			<tr>
				<th class="hostmask">Блокиран</th>
				<th class="banned_by">Блокиран от</th>
				<th class="banned_at">Блокиран на</th>
				<th class="remove"></th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="ban in channel.data" :key="ban.hostmask">
				<td class="hostmask"><ParsedMessage :network="network" :text="ban.hostmask" /></td>
				<td class="banned_by">{{ ban.banned_by }}</td>
				<td class="banned_at">{{ localetime(ban.banned_at) }}</td>
				<td class="remove">
					<button class="remove-ban-btn" aria-label="Премахни" @click="removeBan(ban.hostmask)">
						×
					</button>
				</td>
			</tr>
		</tbody>
	</table>
</template>

<script lang="ts">
import ParsedMessage from "../ParsedMessage.vue";
import localeTime from "../../js/helpers/localetime";
import socket from "../../js/socket";
import {defineComponent, PropType} from "vue";
import type {ClientNetwork, ClientChan} from "../../js/types";

export default defineComponent({
	name: "ListBans",
	components: {
		ParsedMessage,
	},
	props: {
		network: {type: Object as PropType<ClientNetwork>, required: true},
		channel: {type: Object as PropType<ClientChan>, required: true},
	},
	setup(props) {
		const localetime = (date: number | Date) => {
			return localeTime(date);
		};

		// ЛАФЧЕ.ORG: клик на "×" маха бана/мюта директно от бан списъка,
		// без да е нужно ръчно писане на /mode -b команда. ВАЖНО: props.channel
		// тук е СПЕЦИАЛНИЯТ banlist псевдо-канал, не истинският канал - неговото
		// .id не сочи правилно сървърно (сървърът отказваше с "501 b is unknown
		// mode char to me", защото командата се маршрутизираше като user mode
		// вместо channel mode). Затова търсим истинския канал по име в мрежата.
		// ЛАФЧЕ.ORG: клик на "×" маха бана/мюта директно от бан списъка,
		// без да е нужно ръчно писане на /mode -b команда. ВАЖНО: props.channel
		// тук е СПЕЦИАЛНИЯТ banlist псевдо-канал, чието .name всъщност е
		// "Ban list for #канал" (потвърдено с debug alert), не голото име на
		// канала - трябва да махнем префикса, преди да търсим истинския канал.
		const removeBan = (hostmask: string) => {
			const realChannelName = props.channel.name.replace(/^Ban list for /, "");
			const realChannel = props.network.channels.find(
				(c) => c.name === realChannelName && c.type === "channel"
			);

			if (!realChannel) {
				return;
			}

			socket.emit("input", {
				target: realChannel.id,
				text: "/mode -b " + hostmask,
			});

			// ЛАФЧЕ.ORG: премахваме реда веднага от локалния списък (визуално),
			// вместо да чакаме сървъра/презареждане на панела - иначе изглежда
			// сякаш нищо не се е случило
			if (props.channel.data) {
				props.channel.data = props.channel.data.filter(
					(ban: any) => ban.hostmask !== hostmask
				);
			}
		};

		return {
			localetime,
			removeBan,
		};
	},
});
</script>
